import { h } from 'preact';
import cx from 'classnames';
import style from './style';
import Column from '../';

export const ColumnNoPadding = (props) => {
	let { children } = props;

	return (
		<Column class={cx(style.columnNoPadding, props.class)}>
			{children}
		</Column>
	);
};

export default ColumnNoPadding;
